import routerName from '@/constants/routers'

export const getRouteRedirect = (type) => {
  let result = routerName.DASHBOARD
  switch(type){
    case routerName.PRICING.toLowerCase():
      result = routerName.PRICING
      break;
    case routerName.SWIFT_EXPERT.toLowerCase():
      result = routerName.SWIFT_EXPERT
      break;
    case routerName.PRELOADING.toLowerCase():
      result = routerName.PRELOADING
      break;
    case routerName.OPTIMIZE_IMAGE.toLowerCase():
      result = routerName.OPTIMIZE_IMAGE
      break;
    case routerName.LOADING_SCREEN.toLowerCase():
      result = routerName.LOADING_SCREEN
      break;
    default:
      result = routerName.DASHBOARD
  }
  return result
}